
import { defineComponent, ref, getCurrentInstance, onMounted } from 'vue';
import { sendLog, radarLog, RadarLogData } from '@/common/radar';
import LogoutPopup from '@/components/logout-popup/index.vue';
import LoginPopup from '@/components/login/index.vue';

enum NavName {
    Home = 'home',
    Discover = 'discover',
    Shoot = 'shoot',
    Message = 'message',
    Profile = 'profile',
}

interface NavItem {
    name: NavName;
    iconClass: string;
    path?: string;
    logName?: string;
}

const navList: Array<NavItem> = [
    {
        name: NavName.Home,
        iconClass: 'home-icon',
        path: '/foryou',
        logName: 'foryou',
    },
    {
        name: NavName.Discover,
        path: `/discover`,
        iconClass: 'discover-icon',
        logName: 'discover',
    },
    {
        name: NavName.Shoot,
        iconClass: 'shoot-icon',
        logName: 'together',
    },
    {
        name: NavName.Message,
        path: `/message`,
        iconClass: 'news-icon',
        logName: 'message',
    },
    {
        name: NavName.Profile,
        path: `/profile`,
        iconClass: 'profile-icon',
        logName: 'profile',
    },
];

export default defineComponent({
    components: {
        LogoutPopup,
        LoginPopup,
    },
    props: {
        isDark: Boolean,
    },
    setup() {
        const { proxy } = getCurrentInstance() as { proxy: any };
        const activeIndex = ref(0);
        const logoutPopupVisible = ref(false);
        const loginPopupVisible = ref(false);

        const handleChangeLogoutPopupVisible = (visible: boolean) => {
            logoutPopupVisible.value = visible;
        };

        const handleLogoutSuccessfully = (type?: 'logout' | 'delete_account') => {
            proxy.$store.commit('setIsLogin', false);
            handleChangeLogoutPopupVisible(false);
        };

        const handleChangeLoginPopupVisible = (visible: boolean) => {
            loginPopupVisible.value = visible;
        };

        const handleLoginSuccessfully = (isLogin?: boolean) => {
            if (isLogin) {
                proxy.$store.commit('setIsLogin', true);
                handleChangeLoginPopupVisible(false);
            }
        };

        const handleNavClick = (item: NavItem, index: number) => {
            sendLog({
                type: 'click',
                name: 'FUNCTION_MODE',
                value: {
                    // 拿不到photoId
                    button_type: item.logName,
                },
            });

            if (item.name === NavName.Profile) {
                const { isLogin } = proxy.$store.state || {};
                if (!isLogin) {
                    handleChangeLoginPopupVisible(true);
                    return;
                }

                handleChangeLogoutPopupVisible(true);
                return;
            }

            activeIndex.value = index;
            if (item.name === NavName.Discover) {
                const pageSourceMap = {
                    '/foryou': 'foryou',
                };

                const pathName = encodeURIComponent(pageSourceMap[window?.location?.pathname as keyof typeof pageSourceMap]);

                proxy.$router.push({
                    path: item.path,
                    query: {
                        ...proxy.$route.query,
                        page_source: pathName,
                    },
                });
            } else {
                proxy.$bus.emit('footerNav');
            }
            // if (item.path) {
            //   proxy.$router.push({ path: item.path, query: proxy.$route.query });
            // } else {
            //   proxy.$bus.emit('launchApp')
            // }
        };

        onMounted(() => {
            proxy.$store.dispatch('getIsLogin');
        });

        return {
            navList,
            activeIndex,
            loginPopupVisible,
            logoutPopupVisible,
            handleNavClick,
            handleLogoutSuccessfully,
            handleChangeLoginPopupVisible,
            handleChangeLogoutPopupVisible,
            handleLoginSuccessfully,
        };
    },
});
